import '../sass/main.scss';
import 'lazysizes';
import {initHeader} from "./header/header";
import {initFaq} from "./sections/faq";
import Taxonomy from "./taxonomy/taxonomy";
import {Product} from "./product/product";
import {Frontpage} from "./frontpage";
import {initSplide} from "./vendor/splide";

jQuery(document).ready(function ($) {
    initHeader();
    new Taxonomy();
    new Product();
    new Frontpage();
    initFaq();
    initSplide();
});